import { useState } from 'react';
import RequiredRolesData from './RequiredRolesData';

const useRequiredRolesData = () => {
  const [requiredRolesState, setRequiredRolesState] = useState(RequiredRolesData.INITIAL_STATE);

  const getRequiredRolesByOrgLevelTypeId = (orgLevelTypeId) => {
    RequiredRolesData.getRequiredRolesByOrgLevelTypeId(orgLevelTypeId, requiredRolesState, setRequiredRolesState);
  };

  const getRequiredRolesByOrgLevelTypeIdAndOrgUnitId = (orgLevelTypeId, orgUnitId) => {
    RequiredRolesData.getRequiredRolesByOrgLevelTypeIdAndOrgUnitId(orgLevelTypeId, orgUnitId, requiredRolesState, setRequiredRolesState);
  };

  return {
    requiredRolesState,
    setRequiredRolesState,
    getRequiredRolesByOrgLevelTypeId,
    getRequiredRolesByOrgLevelTypeIdAndOrgUnitId
  };
};

export default useRequiredRolesData;